import _ from 'lodash';
import async from 'async';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import update from 'immutability-helper';

import ReactImageMagnify from 'react-image-magnify';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { withStyles } from '@material-ui/core/styles';
import GenericSavingDialog from '../Dialogs/GenericSavingDialog';

import Grid from '@material-ui/core/Grid';
import FMPSubmitButton from '../form/FMPSubmitButton';
import InvoiceDocumentContainer from '../../containers/accounting/InvoiceDocument';
import Page from './Page';
import Transition from '../Dialogs/Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 20px 20px 20px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '98%',
		maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	submitButton: {
		fontSize: 18,
		borderRadius: '100px',
		padding: '20px 30px',
		textTransform: 'uppercase',
	},
	addInputButton: {
		borderRadius: '100px',
		marginTop: 20,
	},
	//
	pageSection: {
		borderBottom: '2px dashed #ccc',
		marginBottom: 30,
		paddingBottom: 30,
	},
	pageIndex: {
		textAlign: 'center',
		fontSize: 24,
		marginBottom: 5,
		textTransform: 'uppercase',
		color: '#666',
		letterSpacing: 2,
		marginTop: 15,
	},
	pageImage: {
		width: '100%',
		border: '1px solid #888',
		marginLeft: 10,
	},
});

class SaveInvoiceDocuments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isActiveDialogOpen: false,
			pages: [],
			formFieldError: { pages: [] },
			isSavingOpen: false,
			savingStatus: undefined,
			isUpdate: false,
		};
	}

	componentDidUpdate(prevProps) {
		const { convertToPagesResult, invoiceDocuments } = this.props;

		if (convertToPagesResult && prevProps.convertToPagesResult !== convertToPagesResult) {
			this.initPages({ convertToPagesResult });
		}

		if (invoiceDocuments && prevProps.invoiceDocuments !== invoiceDocuments) {
			this.initPages({ invoiceDocuments });
		}
	}

	initPages = ({ convertToPagesResult, invoiceDocuments }) => {
		let isUpdate = false;
		let pages = [];
		let originalResourceId;
		if (convertToPagesResult) {
			/** @namespace collections.resourceCollection **/
			const { resourcePages, collections } = convertToPagesResult;
			originalResourceId = convertToPagesResult.originalResourceId;

			const resourceMap = _.keyBy(collections.resourceCollection, 'resourceId');

			//- They are ordered by pageIndex so they are in order
			pages = resourcePages.map((resourcePage) => {
				const resource = resourceMap[resourcePage.resourceId];
				return {
					originalResourceId,
					documentType: '',
					data: {},
					resources: [resource],
				};
			});
		} else if (invoiceDocuments) {
			const { resourceMap } = this.props;
			isUpdate = true;

			pages = invoiceDocuments.map((invoiceDocument) => {
				const { invoiceDocumentId, documentType, pageResourceIds, data } = invoiceDocument;
				return {
					invoiceDocumentId,
					documentType,
					data,
					resources: pageResourceIds.map((resourceId) => {
						return resourceMap[resourceId];
					}),
				};
			});
		}

		//- testing
		if (originalResourceId === 777777777) {
			//- Fake the info
			pages[0].documentType = 'carrierDeliveryTicket';
			pages[0].data = {
				carrierPoNumber: '580132',
			};
			pages[1].documentType = 'stationDeliveryPickupBol';
			pages[1].data = {
				bolNumber: '24622M',
				netGallons: 5710,
				productType: 'unl',
			};
			//pages[2].documentType = 'veederReceipt';
			pages[2].documentType = 'stationDeliveryPickupBol';
			pages[2].data = {
				bolNumber: '0002003625',
				netGallons: 1147,
				productType: 'etoh',
				/*
				terminalSupplier : {
					terminalId : 10,
					supplierId : 2,
				}
				*/
			};
		}

		//- testing
		if (originalResourceId === 888888888) {
			//- Fake the info
			pages[0].documentType = 'carrierDeliveryTicket';
			pages[0].data = {
				carrierPoNumber: '380507',
			};
			pages[1].documentOption = 'pickupBol_etoh';
			pages[1].documentType = 'pickupBol';
			pages[1].data = {
				bolNumber: '24622M',
				netGallons: 8032,
				productType: 'etoh',
			};
			//pages[2].documentType = 'veederReceipt';
			pages[2].documentOption = 'offloadBol_etoh';
			pages[2].documentType = 'offloadBol';
			pages[2].data = {
				bolNumber: '0002003625',
				netGallons: 8010,
				productType: 'etoh',
			};
		}

		this.setState({ isUpdate, pages });
	};

	handleClose = () => {
		this.props.onClose();
	};

	onChange(event, path) {
		const { type, value, checked } = event.target;
		const val = type === 'checkbox' ? checked : value;
		const basePath = path.shift();
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, path, val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	}

	handlePageChange = (r, index) => {
		this.setState((currentState) => {
			const { pages } = currentState;
			const newPages = update(pages, { [index]: { $merge: r } });
			return { pages: newPages };
		});
	};

	//- Go through make sure everything is picked
	handleSaveDocuments = () => {
		//const {convertToPagesResult, showErrors } = this.props;
		const {
			addInvoiceDocument,
			updateInvoiceDocument,
			showErrors,
			onNewInvoiceDocuments,
		} = this.props;
		const { pages } = this.state;

		//- Required fields
		let error;
		const errors = [];
		const formFieldError = { pages: [] };

		pages.forEach((page, i) => {
			const pageError = (formFieldError.pages[i] = {
				data: {},
			});

			const { documentType, data, fields } = page;

			if (!documentType) {
				error = 'Document type is required';
				pageError.documentType = error;
				errors.push(error);
			}

			if (_.isEmpty(fields)) {
				return;
			}

			fields.forEach((field) => {
				const { isRequired, name, label, type } = field;
				if (isRequired && !data[name]) {
					error = `${label} is required`;
					pageError.data[name] = error;
					errors.push(error);
				} else if (isRequired && type === 'terminalSupplierSelect') {
					if (_.isObject(data[name])) {
						const { terminalId, supplierId } = data[name];

						if (!terminalId) {
							error = `Terminal is required`;
							pageError.data[name] = error;
							errors.push(error);
						}

						if (!supplierId) {
							error = `Supplier is required`;
							pageError.data[name] = error;
							errors.push(error);
						}
					}
				}
			});
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			showErrors(errors);
			return;
		}

		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		//- Need to do an async.parallel here
		const invoiceDocuments = [];
		const { isUpdate } = this.state;

		async.each(
			pages,
			(page, callback) => {
				const { invoiceDocumentId, originalResourceId, documentType, data, resources } = page;

				if (documentType === 'ignore') {
					return callback();
				}

				async.waterfall(
					[
						(callback) => {
							if (isUpdate) {
								updateInvoiceDocument({
									params: {
										invoiceDocumentId,
										documentType,
										data,
									},
									callback,
								});
							} else {
								addInvoiceDocument({
									params: {
										documentType,
										data,
										pageResourceIds: _.map(resources, 'resourceId'),
										originalResourceId,
									},
									callback,
								});
							}
						},
						(r, callback) => {
							const invoiceDocument = _.get(r, ['collections', 'invoiceDocumentCollection', 0]);
							if (!invoiceDocument) {
								return callback('Delivery document not returned');
							}

							invoiceDocuments.push(invoiceDocument);
							return callback();
						},
					],
					callback
				);
			},
			(err) => {
				if (err) {
					return showErrors([error]);
				}

				onNewInvoiceDocuments({ invoiceDocuments });

				this.setState({
					savingStatus: 'done',
					invoiceDocuments,
				});
			}
		);
	};

	closeSavingDialog = () => {
		this.setState({ isSavingOpen: false });
		this.handleClose();
	};

	render() {
		const {
			classes,
			fullScreen,
			terminals,
			supplierMap,
			carriers,
			stationDelivery,
			stationInvoice,
			stationDeliveryMap,
			bulkDelivery,
			bulkInvoice,
			bulkDeliveryMap,
			rackTransfer,
		} = this.props;

		const { isSavingOpen, savingStatus, pages, formFieldError, isUpdate } = this.state;

		if (_.isEmpty(pages)) {
			return null;
		}

		let pageNumber = 0;
		const title = isUpdate ? 'Modify Delivery Document' : 'Identify Delivery Documents';

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>{title}</DialogTitle>
					<DialogContent>
						{pages.map((page, index) => {
							const { originalResourceId, resources, documentType, data } = page;

							let pageFormFieldError = {};
							if (!_.isEmpty(formFieldError.pages)) {
								pageFormFieldError = formFieldError.pages[index];
							}

							return (
								<Grid container spacing={2} key={index} className={classes.pageSection}>
									<Grid item md={4} xs={12}>
										<Page
											key={index}
											classes={classes}
											pageNumber={pageNumber}
											stationDelivery={stationDelivery}
											stationInvoice={stationInvoice}
											stationDeliveryMap={stationDeliveryMap}
											bulkDelivery={bulkDelivery}
											bulkInvoice={bulkInvoice}
											rackTransfer={rackTransfer}
											bulkDeliveryMap={bulkDeliveryMap}
											terminals={terminals}
											carriers={carriers}
											supplierMap={supplierMap}
											formFieldError={pageFormFieldError}
											documentType={documentType}
											data={data}
											originalResourceId={originalResourceId}
											onChange={(r) => {
												this.handlePageChange(r, index);
											}}
										/>
									</Grid>
									<Grid item md={8} xs={12}>
										{resources.map((resource, i) => {
											pageNumber++;
											return (
												<div key={i}>
													<div className={classes.pageIndex}>Page {pageNumber}</div>

													{/*
											<img
												alt={`Page ${pageNumber}`}
												className={classes.pageImage}
												src={resource.url}
											/>
											*/}

													<div className={classes.pageImage}>
														<ReactImageMagnify
															{...{
																enlargedImagePosition: 'over',
																smallImage: {
																	alt: `Page ${pageNumber}`,
																	isFluidWidth: true,
																	src: resource.url,
																},
																largeImage: {
																	src: resource.url,
																	width: 1200,
																	height: 1800,
																},
															}}
														/>
													</div>
												</div>
											);
										})}
									</Grid>
								</Grid>
							);
						})}
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>Cancel</Button>

						<FMPSubmitButton
							onClick={this.handleSaveDocuments}
							buttonText={'Save Documents'}
							isDisabled={isSavingOpen}
						/>
					</DialogActions>
				</div>

				<GenericSavingDialog
					open={isSavingOpen}
					onClose={this.closeSavingDialog}
					onContinue={this.closeSavingDialog}
					processingText={'Processing and saving delivery documents'}
					successText={'Documents and data saved. Remember to save your invoice / rack transfer.'}
					status={savingStatus}
				/>
			</Dialog>
		);
	}
}

SaveInvoiceDocuments.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,

	convertToPagesResult: PropTypes.object,
	invoiceDocuments: PropTypes.array,

	addInvoiceDocument: PropTypes.func.isRequired,
	updateInvoiceDocument: PropTypes.func.isRequired,

	stationDelivery: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	stationInvoice: PropTypes.object,

	bulkDelivery: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	bulkInvoice: PropTypes.object,
	rackTransfer: PropTypes.object,

	terminals: PropTypes.array,
	carriers: PropTypes.array,
	supplierMap: PropTypes.object,
	resourceMap: PropTypes.object,

	onNewInvoiceDocuments: PropTypes.func.isRequired,

	classes: PropTypes.object.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors: PropTypes.func,
};

export default _.flow([withStyles(styles), withMobileDialog(), InvoiceDocumentContainer])(
	SaveInvoiceDocuments
);
